//extracted by mini-css-extract-plugin
export default {"insightsCustomCell":"CustomTableCell_insightsCustomCell__u51ay"};;